import Radio from 'backbone.radio';
import ConfirmAndPayDialog from '@/views/dialogs/confirm_and_pay';
import Api from '@/lib/api/api';

function show_confirm_and_pay_dialog(options) {
    const globalCh = Radio.channel('global');

    Api.ajax({
        url: Api.urls.billing(),
        method: 'GET'
    })
    .then((billing_data)=>{
        const confirm_and_pay_dialog = new ConfirmAndPayDialog(billing_data, options);
        globalCh.request('showDialog', confirm_and_pay_dialog);
    });
}

export default show_confirm_and_pay_dialog;